import React, {
    useCallback, useContext, useEffect, useState
} from 'react';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import {
    Button,
    ModalNext,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from '@jutro/components';
import _ from 'lodash';
import SgSessionStorageService from 'sg-session-storage';
import { SgDateUtil, SgSptTripUtils } from 'saga-modules';
import messages from './SgSptExpiredSingleTripModal.messages';

function SgSptExpiredSingleTripModal(props) {
    const {
        modelVM,
        isOpen,
        onResolve
    } = props;

    const translator = useContext(TranslatorContext);
    const [model, updateModel] = useState(_.clone(modelVM));

    useEffect(() => {
        SgSessionStorageService.removeItem(SgSessionStorageService.KEY.IS_RELOADING);
        modelVM.baseData.periodStartDate.value = SgDateUtil.toLocalDateDto(Date.now());
        if (modelVM.quoteData && modelVM.quoteData.offeredQuotes && modelVM.quoteData.offeredQuotes.length > 0) {
            modelVM.quoteData.offeredQuotes.forEach((opt) => {
                // eslint-disable-next-line no-param-reassign
                opt.periodStartDate = SgDateUtil.toMomentDate(modelVM.baseData.periodStartDate.value).utc(true).toISOString();
            });
        }
        updateModel(_.clone(modelVM));
    }, [modelVM]);

    const onContinue = useCallback(() => {
        model.value.hasUpdatedPeriodStartDate = false;
        model.value.isExpiredQuote = false;
        const singleTrip = SgSptTripUtils.getSingleTrip(model);
        singleTrip.departureDate = {};
        singleTrip.returnDate = {};
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.PREVENT_SKIP_TO_QUOTE_IN_RETRIEVAL, true);
        SgSessionStorageService.setItem(SgSessionStorageService.KEY.SPT_SHOW_SINGLE_TRIP_EXPIRED_MESSAGE, true);
        onResolve(model);
    }, [model, onResolve]);

    return (
        <ModalNext isOpen={isOpen}>
            <div className="sgExpiredQuoteModal sgInfoModal">
                <ModalHeader title={translator(messages.SptExpiredSingleTripHeader)} />
                <ModalBody autoFocus={false}>
                    <p>{translator(messages.SptExpiredSingleTripParagraph1)}</p>
                    <p>{translator(messages.SptExpiredSingleTripParagraph2)}</p>
                </ModalBody>
                <ModalFooter>
                    <Button className="sgButton sgTransactionButton" onClick={() => onContinue()}>
                        {translator(messages.SptExpiredSingleTripContinue)}
                    </Button>
                </ModalFooter>
            </div>
        </ModalNext>

    );
}

SgSptExpiredSingleTripModal.propTypes = {
    isOpen: PropTypes.bool,
};

SgSptExpiredSingleTripModal.defaultProps = {
    isOpen: true,
};

export default SgSptExpiredSingleTripModal;
